import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => createStyles({
  attached: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
}));
